module.exports = __webpack_public_path__ + "img/sxsjs6.b403a0a0.png";